export const REM_SIZE = 16;

export const ROOM_FEATURED_IMAGE_ASPECT_RATIO = '4000 / 2667';
